"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var angular_jwt_1 = require("@auth0/angular-jwt");
var service_service_1 = require("../Services/service.service");
var AuthHeaders_1 = require("../api/AuthHeaders");
var i0 = require("@angular/core");
var i1 = require("@auth0/angular-jwt/src/jwthelper.service");
var i2 = require("../Services/service.service");
var AuthGuard = /** @class */ (function () {
    function AuthGuard(jwtHelper, services) {
        this.jwtHelper = jwtHelper;
        this.services = services;
    }
    AuthGuard.prototype.canActivate = function (next, state) {
        var _this = this;
        return new Promise(function (rs, rj) {
            var token = AuthHeaders_1.getAuthToken();
            if (token && !_this.jwtHelper.isTokenExpired(token)) {
                console.log("g-true");
                return rs(true);
            }
            if (state.url) {
                //this.services.showLogin(next.url[0].path);
                _this.services.showLogin(state.url);
            }
            else {
                _this.services.showLogin('/my-ads');
            }
            console.log("g-false");
            return rs(false);
        });
    };
    AuthGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(i0.ɵɵinject(i1.JwtHelperService), i0.ɵɵinject(i2.MainService)); }, token: AuthGuard, providedIn: "root" });
    return AuthGuard;
}());
exports.AuthGuard = AuthGuard;
